<script>
import SubscriptionSalesFilter from "@/components/sale/SubscriptionSalesFilter.vue";
import SalesBase from "./SalesBase.vue";

export default {
  extends: SalesBase,
  data() {
    return {
      filterModal: SubscriptionSalesFilter,
      product_type: "signature"
    };
  }
};
</script>
